import React, { useCallback, useEffect, useRef, useState } from 'react';
import ErrorDialog from './ErrorDialog';
import { clearToken } from '../utils/storage';
import { assignWindowLocationToHostLogin } from '../utils/hostLoginRedirect';
import { markSessionLoggingOut } from '../utils/sessionLogout';
import {
  BSFOOD_AUTH_LOGOUT_EVENT,
  dispatchPersistLegacyMismatchIfNeeded,
} from '../utils/syncSharedStoreToken';

const title = 'Sessione scaduta';
const message =
  'Sessione scaduta. Sarai reindirizzato alla pagina di login fra pochi secondi.';

const REDIRECT_MS = 4000;

/**
 * MF / shared store fires BSFOOD_AUTH_LOGOUT_EVENT; show same UX as handleInvalidToken (ErrorDialog + redirect).
 */
export default function HostSessionExpiredDialog() {
  const [open, setOpen] = useState(false);
  const handlingRef = useRef(false);
  const redirectTimerRef = useRef(null);

  const redirectToLogin = useCallback(() => {
    assignWindowLocationToHostLogin();
  }, []);

  const closeAndRedirect = useCallback(() => {
    if (redirectTimerRef.current != null) {
      window.clearTimeout(redirectTimerRef.current);
      redirectTimerRef.current = null;
    }
    redirectToLogin();
  }, [redirectToLogin]);

  const onSessionExpired = useCallback(() => {
    if (handlingRef.current) return;
    handlingRef.current = true;
    // Sincrono: attivato durante il dispatch dell'evento (dentro apiFetch), quindi
    // PRIMA che il catch del componente chiamante mostri la sua ErrorDialog. Cosi'
    // le ErrorDialog dei figli vengono soppresse e resta solo questo modal.
    markSessionLoggingOut();
    clearToken();
    setOpen(true);
    redirectTimerRef.current = window.setTimeout(closeAndRedirect, REDIRECT_MS);
  }, [closeAndRedirect]);

  useEffect(() => {
    window.addEventListener(BSFOOD_AUTH_LOGOUT_EVENT, onSessionExpired);
    dispatchPersistLegacyMismatchIfNeeded();
    return () => {
      window.removeEventListener(BSFOOD_AUTH_LOGOUT_EVENT, onSessionExpired);
      if (redirectTimerRef.current != null) {
        window.clearTimeout(redirectTimerRef.current);
      }
    };
  }, [onSessionExpired]);

  return (
    <ErrorDialog
      open={open}
      title={title}
      message={message}
      onCloseButtonClicked={closeAndRedirect}
      ignoreSessionLogout
    />
  );
}
